import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import {
  FDListItemText,
} from '@facet-wealth/design';
import Card from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Card';
import { dataAttrs } from 'Helpers/Testing';

// This is a pared down version of an FDListItem without all the padding
export const CondensedListItem = ({
  onClick,
  primaryText,
  test,
}) => {
  return (
    <Card
      onClick={onClick}
      style={{
        boxShadow: 'none',
        cursor: onClick ? 'pointer' : 'none',
      }}
      {...dataAttrs(test)}
    >
      <FDListItemText primaryText={primaryText} />
    </Card>
  );
};

CondensedListItem.defaultProps = {
  onClick: noop,
  test: 'condensed-list-item',
};

CondensedListItem.propTypes = {
  onClick: PropTypes.func,
  primaryText: PropTypes.string.isRequired,
  test: PropTypes.string,
};
